import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-layout',
  templateUrl: './dialog-layout.component.html',
  styleUrls: ['./dialog-layout.component.css']
})
export class DialogLayoutComponent implements OnInit {

  @Output() dismiss : EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
